// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"Q3-z","subtitle":"R3-z","wrapper":"S3-z","leftArrow":"T3-z","rightArrow":"U3-z"};